// src/pages/Rules.js
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from '../hooks/useTranslation';

const Rules = () => {
  const { t, setLanguageFromURL } = useTranslation();
  const { lang } = useParams();

  useEffect(() => {
    if (lang) {
      setLanguageFromURL(lang);
    }
  }, [lang, setLanguageFromURL]);

  return (
    <div 
      className="rules-page"
      role="main"
      aria-labelledby="rules-title"
    >
      <div className="container">
        <header className="page-header">
          <h1 id="rules-title">Klassikalise loterii Vikinglotto mängureeglid Eesti Vabariigis alates 01.01.2024</h1>
        <span>					Käesolevad reeglid kehtivad koos AS Eesti Loto (edaspidi Eesti Loto) klassikaliste loteriide{" "}
</span>
        </header>
  
        <div 
          className="rules-content"
          role="article"
          aria-labelledby="rules-title"
        >
   
          
          <section className="rules" aria-labelledby="section1-heading">
          <ol>
						<li>
							<h4>Mõisted</h4>
							<ul>
								<li><span>1.1.</span> <b>„Vikinglotto“</b> on klassikaline loterii, mida Eesti Loto
									korraldab koos partneritega Eesti Loto klassikaliste loteriide üldreeglites ja
									käesolevates mängureeglites sätestatud korras.</li>
								<li><span>1.2.</span> <b>„Mängukombinatsioon“</b> on Vikinglotto loosimisel osalev numbrite
									kogum, mis on valitud mängija või Eesti Loto infosüsteemi poolt (pliks-plaks) ja mis
									koosneb kuuest (6) põhinumbrist vahemikus üks kuni nelikümmend kaheksa (1-48) ning ühest
									(1) lisanumbrist vahemikus üks kuni viis (1-5).</li>
								<li><span>1.3.</span> <b>„Süsteemimäng”</b> on Vikinglotto loosimisel osalev
									mängukombinatsioonide kogum, mille moodustamiseks tuleb mängijal valida süsteemimängus
									osalevate põhi- ja lisanumbrite arv ja soovitud numbrid. Võimalusi põhi- ja lisanumbrite
									arvu valikuks koos vastava arvu põhi- ja lisanumbrite alusel moodustatavate
									mängukombinatsioonide koguarvuga väljendab järgnev tabel:</li>

								<table className="alt-table">
									<thead>
										<tr>
											<th></th>
											<th></th>
											<th colspan="5">Lisanumbreid</th>
										</tr>
                    </thead>
									<tbody>
										<tr>
											<td></td>
											<td></td>
											<td>1</td>
											<td>2</td>
											<td>3</td>
											<td>4</td>
											<td>5</td>
										</tr>
										<tr>
											<td></td>
											<td>6</td>
											<td className="highlight">1*</td>
											<td className="highlight">2</td>
											<td className="highlight">3</td>
											<td>4</td>
											<td>5</td>
										</tr>
										<tr>
											<td></td>
											<td>7</td>
											<td className="highlight">7</td>
											<td className="highlight">14</td>
											<td className="highlight">21</td>
											<td>28</td>
											<td>35</td>
										</tr>
										<tr>
											<td></td>
											<td>8</td>
											<td className="highlight">28</td>
											<td className="highlight">56</td>
											<td className="highlight">84</td>
											<td>112</td>
											<td>140</td>
										</tr>
										<tr>
											<td></td>
											<td>9</td>
											<td className="highlight">83</td>
											<td className="highlight">168</td>
											<td className="highlight">254</td>
											<td>336</td>
											<td>240</td>
										</tr>
										<tr>
											<td></td>
											<td>10</td>
											<td className="highlight">210</td>
											<td className="highlight">420</td>
											<td className="highlight">630</td>
											<td>840</td>
										</tr>
										<tr>
											<td></td>
											<td>11</td>
											<td>462</td>
											<td>924</td>
										</tr>
										<tr>
											<td></td>
											<td>12</td>
											<td>924</td>
										</tr>
									</tbody>
								</table>

								<span className="alt-content">*Kuuest (6) põhinumbrist ning ühest (1) lisanumbrist moodustatud
									mängukombinatsiooni ei loeta süsteemimänguks.</span>
								<li><span>1.4.</span> <b>„Mängulipik“</b> on vahend, mille abil saab mängija edastada Eesti
									Loto edasimüüjale kirjalikult loosimiste arvu või süsteemimängu valiku, soovitud
									mängukombinatsiooni(d) või pliks-plaks valiku. Vikinglotto mängulipikul saab mängija
									märkida kuni viis mängukombinatsiooni. Süsteemimängu numbreid saab märkida vaid
									mänguväljal A ning mängida saab kuni 10 põhinumbri ja kuni 3 lisanumbriga (mängulipikul
									valitavad kombinatsioonid on punktis 1.3 toodud tabelis tähistatud halliga).
								</li>
                <li><span>1.5.</span> <b>„Partner“</b> on Vikinglottot korraldav litsentseeritud
									loteriikorraldaja.</li>
								<li><span>1.6.</span> <b>„Mängupäev”</b> on võidunumbrite loosimise ja loosimise võitude
									selgumise päev, milleks on iga nädala kolmapäev. Partnerite ühisel otsusel võib
									mängupäeva erakorralistel juhtudel muuta.</li>
							</ul>
						</li>
						<li>
							<h4>Loosimisel osalemine</h4>
							<ul>
								<li><span>2.1.</span> Loosimisel osalemiseks teeb mängija pileti ostmisega panuse
									mängukombinatsioonile. Süsteemimängu korral teeb mängija panuse valitud hulga põhi- ja
									lisanumbritest moodustatud mängukombinatsioonidele.</li>
								<li><span>2.2.</span> Vikinglotto piletil võib olla üks (1) kuni kümme (10)
									mängukombinatsiooni või üks süsteemimäng.</li>
								<li><span>2.3.</span> Vikinglotto pileti saab osta korraga kuni kümneks loosimiseks.
									Mängulipikuga saab pileti osta üheks (1), kaheks (2), kolmeks (3), viieks (5) või
									kümneks (10) eelseisvaks järjestikuseks loosimiseks. Süsteemimängu saab mängulipikuga
									osta korraga üheks loosimiseks. Eesti Loto jätab endale õiguse piirata piletite
									etteostmise võimalust.</li>
								<li><span>2.4.</span> Ühe mängukombinatsiooni hind (panus) ühe loosimise kohta on 1,50 eurot
									ja pileti hind arvutatakse, korrutades hinna mängukombinatsioonide ja loosimiste arvuga.
								</li>
								<li><span>2.5.</span> Pileti saab osta:
									<ul>
										<li><span>2.5.1.</span> Eesti Loto edasimüüjate müügipunktidest, esitades müüjale
											täidetud mängulipiku, või teatades müüjale soovitud mängukombinatsiooni(d) ja
											loosimiste arvu.</li>
										<li><span>2.5.2.</span> interneti vahendusel Eesti Loto müügikeskkonnas;</li>
										<li><span>2.5.3.</span> mobiiltelefoni vahendusel, helistades numbrile 17788*2.</li>
									</ul>
								</li>
								<li><span>2.6.</span> Piletite müük konkreetsele loosimisele lõpetatakse selle loosimise
								mängupäeval kell 18.00 Kesk-Euroopa aja (CET) järgi (Eesti aja järgi kell 19.00).</li>
							</ul>
						</li>
						<li>
							<h4>Vikinglotto võidunumbrite loosimine</h4>
							<ul>
								<li><span>3.1.</span> Vikinglotto loosimine toimub igal mängupäeval kell 19.00 Kesk-Euroopa
									aja (CET) järgi (Eesti aja järgi kell 20.00). Vikinglotto loosimise viib läbi Norsk
									Tipping A/S, asukohaga Hamar, Norra.</li>
								<li><span>3.2.</span> Loosimisel kasutatakse kahte lototroni. Esimeses lototronis
									kasutatakse pallikomplekti numbritega ühest (1) neljakümne kaheksani (48), teises
									lototronis kasutatakse pallikomplekti ühest (1) viieni (5).</li>
								<li><span>3.3.</span> Loosimise käigus loositakse:
									<ul>
										<li><span>3.3.1.</span> esmalt esimese lototroniga kuus (6) põhinumbrit vahemikus
											üks (1) kuni nelikümmend kaheksa (48);</li>
										<li><span>3.3.2.</span> seejärel teise lototroniga üks (1) lisanumber vahemikus üks
											(1) kuni viis (5).</li>
									</ul>
								</li>
							</ul>
						</li>
						<li>
						
					
              <h4>Vikinglotto lisavõidud</h4>
              <ul>

			 
<li><span>4.1.</span> Vikinglotto lisavõitudena loositakse aasta jooksul välja 1 200 000 (üks miljon kakssada tuhat) eurot. Eesti Loto teavitab perioodiliste lisavõitude loosimiste toimumisest ja tingimustest mängijaid vähemalt üks kuu enne loosimist oma veebilehe ja meedia vahendusel. Lisavõitude loosimises osalevad kõik vastaval perioodil ostetud Vikinglotto piletid (ilma täiendava registreerimise vajaduseta).</li>
<li><span>4.2.</span> Lisavõitude loosimiseks kasutatakse juhuarvu generaatorit.</li>
<li><span>4.3.</span> Vikinglotto lisavõidud makstakse välja Eesti Loto reservfondist.</li>
<li><span>4.4.</span> Vikinglotto lisavõitude loosimised viiakse läbi Eesti Loto kontoris, aadressil Hallivanamehe 4, Tallinn või telestuudios.</li>

</ul>
          
          
          
          	</li>
						<li>
							<h4>Võidud, võidufond ja selle jaotus</h4>
							<ul>
								<li><span>5.1.</span> Võidud jagunevad võidutasanditesse olenevalt loositud numbritega kokku
									langevate mängukombinatsiooni numbrite arvust. Võidutasandid on nummerdatud alates
									esimesest (I) võidutasandist, mis on kõrgeim võidutasand (kõige enam loositud numbritega
									kokkulangevaid numbreid), kuni üheksanda (IX) võidutasandini, mis on madalaim (kõige
									vähem loositud numbritega kokkulangevaid numbreid).</li>
								<li><span>5.2</span> Vikinglotto võidutasandid on järgmised:
									<table className="table-half">
										<tr>
											<th>Võidutasand</th>
											<th>Loositud numbritega kokkulangevad numbrid</th>
										</tr>
										<tr>
											<td>I</td>
											<td>6 põhinumbrit</td>
										</tr>
										<tr>
											<td>II</td>
											<td>6 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>III</td>
											<td>5 põhinumbrit</td>
										</tr>
										<tr>
											<td>IV</td>
											<td>5 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>V</td>
											<td>4 põhinumbrit</td>
										</tr>
										<tr>
											<td>VI</td>
											<td>4 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>VII</td>
											<td>3 põhinumbrit</td>
										</tr>
										<tr>
											<td>VIII</td>
											<td>3 põhinumbrit + 1 lisanumber</td>
										</tr>
										<tr>
											<td>IX</td>
											<td>2 põhinumbrit + 1 lisanumber</td>
										</tr>
									</table>
								</li>
								<li><span>5.3.</span> Vikinglotto võidufondi arvatakse igal loosimisel 50% kõikide mängijate
									poolt konkreetseks loosimiseks tehtud panustest.</li>
								<li><span>5.4.</span> Võidufond jaguneb järgmiselt:
									<ul>
										<li><span>5.4.1.</span> Vikinglotto I võidutasandi (jackpot’i) võidufondiks, kuhu
											kantakse igast panusest null koma kolmteist (0,13) eurot;</li>
										<li><span>5.4.2.</span> Vikinglotto II võidutasandi võidufondiks, kuhu kantakse
											igast panusest null koma null kolmteist (0,013) eurot;.</li>
										<li><span>5.4.3.</span> Vikinglotto ühiseks reservfondiks, kuhu kantakse igast
											panusest null koma null nelikümmend kaks (0,042) eurot.</li>
										<li><span>5.4.4.</span> Eesti Loto omavõidufondiks, mille moodustab ülejäänud osa
											võidufondist ja mis jaguneb III kuni IX võidutasandi ja Eesti Loto reservfondi
											vahel järgmiselt:
											<table className="table-half remove-margin">
											<tbody>	<tr>
													<th>Võidu tasand</th>
													<th>Osakaal omavõidufondist</th>
												</tr>
												<tr>
													<td>III</td>
													<td>16 %</td>
												</tr>
												<tr>
													<td>IV</td>
													<td>7,5 %</td>
												</tr>
												<tr>
													<td>V</td>
													<td>11 %</td>
												</tr>
												<tr>
													<td>VI</td>
													<td>8.5 %</td>
												</tr>
												<tr>
													<td>VII</td>
													<td>8.5 %</td>
												</tr>
												<tr>
													<td>VIII</td>
													<td>12.5 %</td>
												</tr>
                        <tr>
												<td>IX</td>
												<td>7.5 %</td>
												</tr>
												<tr>
													<td>Eesti Loto reservfond</td>
													<td>28.5 %</td>
												</tr>	</tbody>
											</table>
										</li>
									</ul>
								</li>
								<li><span>5.5.</span> Vikinglotto I ja II võidutasandi võidufondid ja Vikinglotto reservfond
									on partneritega ühised, ülejäänud võidufondid moodustuvad vaid Eestis müüdud
									mängukombinatsioonide põhiselt.</li>
								<li><span>5.6.</span> I võidutasandi võidufond koosneb:
									<ul>
										<li><span>5.6.1.</span> kõigi partnerite poolt selleks konkreetseks loosimiseks
											müüdud mängukombinatsioonide koguarvust korrutatuna null koma kolmeteistkümne
											(0,13) euroga;</li>
										<li><span>5.6.2.</span> eelmistest loosimistest vastavalt mängureeglite punktile
											5.12 edasi kandunud I võidutasandi võidufondist;</li>
										<li><span>5.6.3.</span> Vikinglotto ühise reservfondi limiiti ületavast summast
											vastavalt p. 5.10;</li>
										<li><span>5.6.4.</span> II võidutasandi võidufondi limiiti ületavast summast p. 5.9
											nimetatud juhul.</li>
									</ul>
								</li>
								<li><span>5.7.</span> I võidutasandi võidufondile on kehtestatud minimaalne suurus 3 000 000
									(kolm miljonit) eurot ja maksimaalne suurus 25 000 000 (kakskümmend viis miljonit)
									eurot. Võidufondi minimaalne suurus garanteeritakse Vikinglotto ühisest reservfondist.
									Juhul kui I võidutasandi võidufond ületab võidufondi maksimaalse suuruse, lisatakse üle
									jääv summa sama loosimise II võidutasandi võidufondile.</li>
								<li><span>5.8.</span> II võidutasandi võidufond koosneb:
									<ul>
										<li><span>5.8.1.</span> kõigi partnerite poolt selleks konkreetseks loosimiseks
											müüdud mängukombinatsioonide koguarvust korrutatuna null koma null
											kolmeteistkümne (0,013) euroga;</li>
										<li><span>5.8.2.</span> eelmistest loosimistest vastavalt mängureeglite punktile
											5.12. edasi kandunud II võidutasandi võidufondist;</li>
										<li><span>5.8.3.</span> I võidutasandi võidufondi limiiti ületavast summast
											vastavalt p. 5.7.</li>
									</ul>
								</li>
								<li><span>5.9.</span> II võidutasandi võidufondile on kehtestatud maksimaalne suurus 25 000
									000 (kakskümmend viis miljonit) eurot. Juhul kui II võidutasandi võidufond ületab
									võidufondi maksimaalse suuruse, lisatakse üle jääv summa järgmise loosimise I
									võidutasandi võidufondile.</li>
								<li><span>5.10.</span> Vikinglotto ühisele reservfondile on kehtestatud maksimaalne suurus
									20 000 000 (kakskümmend miljonit) eurot. Juhul kui Vikinglotto ühise reservfondi suurus
									ületab maksimaalse suuruse, lisatakse üle jääv summa järgmise loosimise I võidutasandi
									võidufondile.</li>
								<li><span>5.11.</span> Võidutasandi võitja(te)ks on mängija(d), kes on saanud võidutasandile
									vastava tabamuse. Võidutasandi võidu suurus saadakse vastava võidutasandi võidufondi
									jagamisel vastava võidutasandi võitjate arvuga.</li>
								<li><span>5.12.</span> Võidu puudumise korral konkreetsel võidutasandil lisatakse selle
									võidutasandi võidufond järgmise loosimise sama võidutasandi võidufondile. Protseduuri
									jätkatakse loosimisest loosimiseni kuni vastava võidutasandi võidu (võitude)
									väljaloosimiseni.</li>
								<li><span>5.13.</span> Ühe mängukombinatsiooniga on võimalik saada ühel loosimisel vaid üks
									võit. Kui mängija mängukombinatsioon vastab erinevate võidutasandite tabamustele, siis
									loetakse võiduks kõrgeima võidutasandi võit. </li>
								<li><span>5.14.</span> Eesti Loto poolt müüdud Vikinglotto mängukombinatsiooniga saadud
									võidu minimaalne suurus on üks euro ja viiskümmend senti (1,50 €). Juhul kui võidu
									arvestuslik suurus on alla ühe euro ja viiekümne sendi (1,50 €), katab Eesti Loto
									puuduoleva summa Eesti Loto reservfondist.</li>
								<li><span>5.15.</span> Kõik I ja II võidutasandi võidud ümardatakse kümne (10) sendi
									täpsusega allapoole ning võit makstakse välja vastavalt ümardatud suurusele. Ümardustest
									tekkiv vahe arvatakse Vikinglotto ühisesse reservfondi.</li>
								<li><span>5.16.</span> Kõik III- IX võidutasandi võidud ümardatakse kümne (10) sendi
									täpsusega allapoole ning võit makstakse välja vastavalt ümardatud suurusele. Ümardustest
									tekkiv vahe arvatakse Eesti Loto reservfondi.</li>
								<li><span>5.17.</span> Kõik I ja II võidutasandi vormistamata võidud suuruses 3 000 000
									(kolm miljonit) eurot või üle selle kantakse Vikinglotto ühisesse reservfondi. Väiksemad
									vormistamata võidud arvatakse Eesti Loto reservfondi.</li>
								<li><span>5.18.</span> Eesti Loto edasimüüjad maksavad võidunõuded välja ainult Eesti Loto
									edasimüüjate poolt väljastatud ja müüdud piletite alusel. Eesti Loto ei maksa võidunõuet
									välja pileti alusel, mis on ostetud mõne teise partneri vahendusel.</li>
							</ul>
						</li>
					</ol>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Rules;